function getShippingAndDeliveryDates() {
  const daysOfWeek = ["Lun", "Mar", "Miérc", "Jue", "Vier", "Sáb", "Dom"];
  const monthsOfYear = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

  let now = luxon.DateTime.now().setZone('America/Mexico_City');
  //let now = luxon.DateTime.fromObject({ year: 2025, month: 1, day: 19, hour: 12, minute: 36 }, { zone: 'America/Mexico_City' });
  const currentHour = now.hour;
  const currentDay = now.weekday;

  let shippingDate;
  let deliveryDate;

  const isHoliday = (date) => {
    return (
      (date.month === 12 && (date.day === 25)) || 
      (date.month === 1 && date.day === 1)
    );
  };

  const getNextBusinessDay = (date) => {
    do {
      date = date.plus({ days: 1 });
    } while (date.weekday > 5 || isHoliday(date));
    return date;
  };
 
  if (currentDay >= 1 && currentDay <= 5) {
    if (currentHour < 14) {
      shippingDate = now;
      deliveryDate = getNextBusinessDay(now);
    } else {
      shippingDate = getNextBusinessDay(now);
      deliveryDate = getNextBusinessDay(shippingDate);
    }
  } else { // Sábado y Domingo
    shippingDate = getNextBusinessDay(now.plus({ days: currentDay === 6 ? 1 : 0 }));
    deliveryDate = getNextBusinessDay(shippingDate);
  }


  const formatShippingDate = () => {
    return now.hasSame(shippingDate, 'day')
      ? `hoy ${daysOfWeek[now.weekday - 1]} ${shippingDate.day} ${monthsOfYear[shippingDate.month - 1]}`
      : `${daysOfWeek[shippingDate.weekday - 1]} ${shippingDate.day} ${monthsOfYear[shippingDate.month - 1]}`;
  };

  const formatCurrentDate = () => {
    const dayName = daysOfWeek[now.weekday - 1];  // Obtener el nombre del día
    return `${dayName}, ${now.toFormat('dd-MM-yyyy HH:mm')}`;
  };

  return {
    shippingMessage: formatShippingDate(),
    currentDateMessage: formatCurrentDate(),
  };
}

document.addEventListener('DOMContentLoaded', function () {
  const shippingElement = document.querySelector('.date__estimated');
  const currentDateElement = document.querySelector('.date__current');

  if (shippingElement) {
    const { shippingMessage } = getShippingAndDeliveryDates();
    shippingElement.innerHTML = shippingMessage;
  }

  if (currentDateElement) {
    const { currentDateMessage } = getShippingAndDeliveryDates();
    currentDateElement.innerHTML = currentDateMessage;
  }
});
